import React from 'react'

interface SwitchProps {
  checked?: boolean
  onChange?: (checked: boolean) => void
  className?: string
  id?: string
  disabled?: boolean
}

const Switch: React.FC<SwitchProps> = ({
  checked = false,
  onChange,
  className = '',
  id,
  disabled = false,
}) => {
  return (
    <div className={className}>
      <div
        id={id}
        role="switch"
        aria-checked={checked}
        aria-disabled={disabled}
        onClick={() => !disabled && onChange?.(!checked)}
        className={`relative inline-flex h-6 w-[42px] items-center rounded-full transition-colors focus:outline-none ${
          checked ? 'bg-black' : 'bg-gray-300'
        } ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
      >
        <span className="sr-only">Toggle</span>
        <span
          aria-hidden="true"
          className={`pointer-events-none inline-block size-5 transform rounded-full border bg-white shadow transition ease-in-out ${
            checked ? 'translate-x-5' : 'translate-x-0.5'
          }`}
        />
      </div>
    </div>
  )
}

export default Switch
